{
  "move_node": {
    "title": "Escolha um novo local para o {{ nodeType }}",
    "multi_title": "Escolha um novo local para os {{ count }} itens selecionados",
    "empty_title": "Escolha um novo local",
    "success": "Os itens foram movidos com sucesso.",
    "multiple_items": "Vários itens",
    "no_permission_tooltip": "Você não tem permissão para mover itens para esse local"
  },
  "permissions": {
    "request_access": "Solicitar acesso",
    "no_read_permissions": "Você não tem permissões de leitura neste item",
    "no_write_permissions": "Você não tem permissões de gravação neste item"
  },
  "mappingLibraries": {
    "My Workspace": "Meu espaço de trabalho",
    "My workspace": "Meu espaço de trabalho",
    "Team Workspace": "Espaço de trabalho da equipe",
    "Team workspace": "Espaço de trabalho da equipe",
    "Shared library": "Espaço de trabalho da equipe",
    "Recently viewed": "Visto recentemente",
    "Recently Viewed": "Visto recentemente",
    "Favourites": "Favoritos",
    "add_to_favourites": "adicionar aos favoritos",
    "remove_from_favourites": "remover dos favoritos"
  },
  "copy_node": {
    "button": "Copiar {{ nodeType }}",
    "title": "Escolha um local para copiar o {{ nodeType }}",
    "multi_title": "Escolha um local para copiar os itens selecionados",
    "empty_title": "Escolha um local",
    "success": "Os itens foram copiados com sucesso.",
    "multiple_items": "Vários itens",
    "no_permission_tooltip": "Você não tem permissão para copiar itens para este local",
    "copy_with_map_objects": "Copiar objetos do mapa",
    "options_title": "Opções de cópia",
    "options_submit_button": "Copiar",
    "options_description": {
      "map_objects_only": "Escolha se deseja incluir objetos de mapa ao copiar.",
      "map_objects_and_permissions": "Escolha se deseja incluir objetos de mapa e permissões ao copiar."
    }
  },
  "delete_node": {
    "selected_items_cannot_be_deleted": "Você não pode excluir o (s) item (s) selecionado (s)"
  },
  "create_node": {
    "change_location": "Alterar localização"
  }
}